'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'image';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f03e';
var svgPathData = ['M48 80l0 334.8 6.2-6.8 72-80 16.9-18.8L161 327l33.3 33.3L284.5 234 303.8 207l19.6 26.9 128 176L464 427.2 464 80 48 80zm144 96a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z', 'M464 80l0 347.2-12.6-17.3-128-176L303.8 207 284.5 234 194.3 360.3 161 327l-17.9-17.9-16.9 18.8-72 80L48 414.8 48 80l416 0zM48 32L0 32 0 80 0 432l0 48 48 0 416 0 48 0 0-48 0-352 0-48-48 0L48 32zM192 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;